// components/Posts/Post/Post.js
import React from 'react';
import { Card, CardActions, CardContent, CardMedia, Button, Typography } from '@material-ui/core/';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import CreateIcon from '@material-ui/icons/Create';
import MenuIcon from '@material-ui/icons/Menu';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { likePost, deletePost } from '../../../actions/posts';
import useStyles from './styles';

const Post = ({ post, setCurrentId }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

// Custom function to handle delete click with confirmation dialog
const handleDeleteClick = (postId) => {
  const userConfirmed = window.confirm("Are you sure you want to delete this post?");
  if (userConfirmed) {
    dispatch(deletePost(postId));
  }
};

  return (

    <Card className={classes.card} 
     style={{
       backgroundColor: "rgb(70,70,100)",
       color: "white",
      
        }}>

      <CardMedia style={{backgroundColor:"rgba(0,0,50,0.37)"}} className={classes.media} image={post.selectedFile || 'https://wallpapercave.com/wp/wp2686941.jpg' /* 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png' */ } title={post.title} />

      <div className={classes.overlay}>

        {/* <Typography variant="h6">{post.creator}</Typography> */}

        {/* <Typography variant="body2">{moment(post.createdAt).fromNow()}</Typography> */} {/* Date*/}
        
      </div> 

      <div className={classes.overlay2}>

        <div style={{paddingLeft: "30px"}}></div>
        
        
      </div>

      {/* <div className={classes.details} style={{margin: "0px"}} >
         <Typography variant="body2" color="textSecondary" component="h2">{post.tags.map((tag) => `#${tag} `)}</Typography> 
      </div>  */} 


      {/* div for the card text and buttons together */}
      <div style={{  
        backgroundColor:"",
        display: "flex", 
        flexDirection: "column",  
        flex: "1",
        justifyContent: "space-between", 


      }}> 

      {/* div for the card text only */}
      <div style={{
        backgroundColor: "",
        
      }}> 


      <Typography className={classes.title} gutterBottom variant="h5" component="h2"
      style={{
        marginTop: "20px",
        marginBottom: "0px", 
        paddingBottom: "5px",
        color: "rgb(200,200,250)", 

      }}
      >{post.title}</Typography>

      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p" 
        style={{ 
          marginTop: "-10px",
          paddingTop: "0px", 
          color: "rgb(200,200,210)",
          paddingBottom: "30px", 

         }}
        >{post.message}</Typography>
      </CardContent>

      </div> {/* div for the card text only */}


       {/*  div for the edit and delete buttons only */}  
       <div style={{
         backgroundColor:"",
         marginTop:"auto",
         marginLeft:"-5px",

       }}> 

       

      <CardActions className={classes.cardActions}  style={{
        /* marginBottom: "", */ 
      }}>

      <Button size="small" 
      style={{
        color: "rgba(160,160,255,1.0)", 
    

      }} 
      color="primary" onClick={() => setCurrentId(post._id)}><MenuIcon fontSize="small"style={{
        marginRight: "4px",
      }} /> Edit</Button>

        {/* <Button size="small" color="primary" onClick={() => dispatch(likePost(post._id))}><ThumbUpAltIcon fontSize="small" /> Like {post.likeCount} </Button> */}

 <Button size="small" 
          style={{ color: "rgba(160,160,255,1.0)" }} 
          color="primary" 
          onClick={() => handleDeleteClick(post._id)}>
          <DeleteIcon fontSize="small" 
            style={{ 
              marginRight: "1px",
              color: "rgba(160,160,255,0.65)", 
            }} /> 
          Delete
        </Button>
      </CardActions>

      </div> {/* div for edit and delete buttons only */}

      

      </div> {/* div for the card text and buttons together */}

    </Card>
  );
};

export default Post;


// components/Posts/Post/Post.js